module.exports = __webpack_public_path__ + "img/private-image.d7ab45c4.jpeg";